import React from "react";
import { ButtonCardProps } from "./ButtonCard.types";
import { ButtonCardBox } from "./ButtonCard.style";
import {
  ComponentMapping,
  Container
} from "@adobe/aem-react-editable-components";
import { CoreContainerState } from "@adobe/aem-core-components-react-spa";
import Modal from "../../Modal/Modal";

interface ButtonCardState extends CoreContainerState {
  isModalOpen: boolean;
}

export default class ButtonCard extends Container<
  ButtonCardProps,
  ButtonCardState
> {
  constructor(props: ButtonCardProps) {
    super(props);

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
      isModalOpen: false,
    };
  }

  handleButtonClick = () => {
    if (this.props.isModal) {
      this.setState({ isModalOpen: true });
    }
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  render() {
    const {
      backgroundColor,
      label,
      link,
      target,
      isInEditor,
      modalTitle,
      modalDescription,
    } = this.props;
    const { isModalOpen } = this.state;

    return (
      <>
        <ButtonCardBox
          className="buttoncard"
          $backgroundcolor={backgroundColor}
          onClick={this.handleButtonClick}
          href={isInEditor ? "#" : link}
          target={isInEditor ? "_self" : target ? "_blank" : "_self"}
          rel="noopener noreferrer"
          aria-label={label}
        >
          {this.childComponents && (
            <>
              {this.childComponents.length > 0 && (
                <div className="buttoncard__icon">
                  {this.childComponents[0]}
                </div>
              )}

              {this.childComponents.length > 1 && (
                <div className="buttoncard__text">
                  {this.childComponents.slice(1).map((item, k) => (
                    <div key={k + 1}>{item}</div>
                  ))}
                </div>
              )}
            </>
          )}
        </ButtonCardBox>
        {this.childComponents.length < 3 && this.placeholderComponent}

        {isModalOpen && (
          <Modal onClose={Function} onReturn={Function} returnDisabled={true}>
            <h3 className="modal__title">{modalTitle}</h3>
            <p className="modal__subtitle">{modalDescription}</p>
          </Modal>
        )}
      </>
    );
  }
}

